import Swiper from "swiper11";
import sideBar1_Init from "@common/components/sideBar-1";
import dialogFormInit from "@common/components/dialogForm-1";
import { Autoplay, Pagination, Thumbs, Navigation } from "swiper11/modules";
import { initFancyBox, initToTop, globalSearch, addDefaultTabelStyle } from "@common/utils/initUtils";
import { ImportBundle, handleSendInquiry, isMobile, lazyLoad } from "@common/utils/utils";
import { filpHeight } from "@common/utils/additionalUtils";
import { createdThumbs } from "@common/utils/swiperUtils";
import { cartInstance } from "@common/utils/vueUtils";
common();
initEvent();
initSwiper();
function resizeFlexTable() {
  if (!$(".download-1").length) return;
  let c1Width = 0;
  let c2Width = 0;
  const col1 = $(".download-1 .download-1-list .list_col-1");
  const col2 = $(".download-1 .download-1-list .list_col-2");
  col1.width("auto");
  col2.width("auto");
  if (isMobile()) {
    requestAnimationFrame(() => {
      col1.each((_i, item) => {
        const currentWidth = $(item).width() || 0;
        if (currentWidth > c1Width) {
          c1Width = currentWidth;
        }
      });
      col2.each((_i, item) => {
        const currentWidth = $(item).width() || 0;
        if (currentWidth > c2Width) {
          c2Width = currentWidth;
        }
      });

      col1.width(c1Width);
      col2.width(c2Width);
    });
  }
}

function common() {
  initFancyBox();
  ImportBundle({ type: "js" }, [
    {
      src: "https://static.addtoany.com/menu/page.js",
      async: true,
      fn: () => {
        const a2a_config = window.a2a_config || {};
        a2a_config.onclick = 1;
        window.a2a_config = a2a_config;
      },
    },
  ]);
  ImportBundle({ type: "css" }, ["https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css", "https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css"]);

  globalSearch();
}

function initEvent() {
  addDefaultTabelStyle();
  initFancyBox();
  lazyLoad();
  sideBar1_Init();
  filpHeight(".productList-1 .productList-1_SEO .showBtn", ".productList-1 .productList-1_SEO article", 3);
  handleSendInquiry({ formId: "#contactUs-6-Form", trigger: "#contactUs-6-Submit" });
  handleSendInquiry({ formId: "#Inquiry-form", trigger: "#Inquiry-submit" });
  initToTop(".serviceDetail-1 .serviceDetail-1-main .serviceDetail-1-btn .serviceDetail-1-toTop");
  resizeFlexTable();
  (async () => {
    if (!$(".productList-1,.productDetail-3").length) return;
    const inquiryOptions: SendInquiryOpts["opts"] = {};
    if ($(".productList-1").length) {
      const V = await cartInstance({
        pageMarker: ".productList-1",
      });
      if (V) {
        inquiryOptions.onBeforeSend = (data) => {
          data.set("product_id", V.idList.join(","));
        };
        // inquiryOptions.onSuccess = () => {
        //   V.handleCart(V.idList);
        // };
      }
      const buildingContent = (list: HTMLElement[]) => {
        const arr: string[] = [];
        list.forEach((i) => {
          const name = $(i).find(".name").text();
          const count = $(i).find("input").val();
          const str = name + " * " + count;
          arr.push(str);
        });
        return arr.join("\r\n");
      };

      // 购物车页面内
      if ($("#cart").length && V?.productList.length) {
        const container = $("#SubmitProductList");
        $(".dialogForm").addClass("extra");
        container.css("display", "flex");
        const Fragment = document.createDocumentFragment();
        const ul = $("<ul></ul>");
        V.productList.forEach((pro) => {
          const li = $(
            `<li>
            <p class='name'>${pro.name}</p>
            <input type='number' min='1' value='1'/>
          </li>`
          );
          ul.append(li);
        });
        container.append(Fragment.appendChild(ul[0]));
        inquiryOptions.onBeforeSend = (data) => {
          data.set("product_id", V.idList.join(","));
          const content = `Product:\r\n${buildingContent(Array.from($(container).find("li")))}\r\n${data.get("content")}`;
          data.set("content", content);
        };
      }
    } else if ($(".productDetail-3").length) {
      const trigger = $(".productDetail-3 .like-component");
      const currentId = Number(trigger.attr("data-id")) || 0;
      const isInCart = () => {
        const idList = JSON.parse(localStorage.getItem("cartList") || "[]") as Array<number>;
        return idList.some((id) => id === currentId);
      };
      if (isInCart()) {
        trigger.addClass("checked");
      }
      trigger.on("click", () => {
        let idList = JSON.parse(localStorage.getItem("cartList") || "[]") as Array<number>;
        if (isInCart()) {
          idList = idList.filter((id) => id !== currentId);
          trigger.removeClass("checked");
        } else {
          idList.push(currentId);
          trigger.addClass("checked");
        }
        localStorage.setItem("cartList", JSON.stringify(idList));
      });
    }
    dialogFormInit({ opts: inquiryOptions });
  })();
}

function initSwiper() {
  new Swiper(".aboutUs-2 .aboutUs-2_team .swiper-box .swiper", {
    modules: [Autoplay],
    loop: true,
    autoplay: {
      disableOnInteraction: false,
    },
    slidesPerView: 4,
    spaceBetween: 10,
    breakpoints: {
      620: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      150: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });
  new Swiper(".productDetail-3 .productDetail-3_header .main-swiper .swiper", {
    modules: [Thumbs, Autoplay, Pagination],
    loop: true,
    pagination: {
      el: ".productDetail-3 .productDetail-3_header .main-swiper .swiper-pagination",
      clickable: true,
    },
    autoplay: {
      disableOnInteraction: false,
    },
    speed: 550,
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, ".productDetail-3 .productDetail-3_header .thumbs-swiper .swiper", {
          swiperOptions: {
            slidesPerView: 6,
            spaceBetween: 30,
            breakpoints: {
              1200: {
                slidesPerView: 6,
                spaceBetween: 30,
              },
              620: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              320: {
                slidesPerView: 4,
                spaceBetween: 15,
              },
            },
          },
        });
      },
    },
  });
  new Swiper(".serviceDetail-1 .serviceDetail-1-main .swiper-box .swiper", {
    modules: [Autoplay, Navigation],
    autoplay: {
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: ".serviceDetail-1 .serviceDetail-1-main .prev",
      nextEl: ".serviceDetail-1 .serviceDetail-1-main .next",
    },
  });
  new Swiper(".faq-2 .faq-2-download .swiper-box .swiper", {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 30,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      620: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
